import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import AppRoute from '@/components/route/AppRoute';
import Loading from '@/components/shared/Loading';
import { publicRoutes } from '@/configs/routes.config';

const AllRoutes = () => {
	return (
		<Routes>
			{publicRoutes.map(route => (
				<Route
					key={route.path}
					path={route.path}
					element={
						<AppRoute
							routeKey={route.key}
							component={route.component}
							{...route.meta}
						/>
					}
				/>
			))}
			<Route path="*" element={<Navigate replace to="/" />} />
		</Routes>
	);
};

const Views = () => {
	return (
		<Suspense fallback={<Loading loading={true} />}>
			<AllRoutes />
		</Suspense>
	);
};

export default Views;
